import DOMPurify from 'dompurify'

/**
 * Sanitiser for SOP rich-text HTML (SopsPage).
 *
 * SOP HTML is NOT fully trusted: `sop.create` is an edit-level operation
 * (Managers / Team Leaders can author SOPs), content can be AI-extracted from
 * an uploaded document, and it can come from the external SOP provider.
 *
 * DOMPurify's defaults already stop script execution (no <script>, event
 * handlers, `javascript:` URLs, iframes) but still allow a working
 * `<form action="https://…">` with a password field + submit button, and a
 * `<style>` block (also inside <svg>) that restyles or hides the whole app.
 * SOP content never needs those, so they are forbidden here. `input` is kept
 * on purpose — checklist checkboxes use it, and without a form an input can't
 * send data anywhere.
 *
 * Inline `style` attributes are kept for formatting (alignment, colour); the
 * `.sop-prose` container's paint containment (index.css) stops a
 * `position:fixed` overlay from escaping the SOP box.
 */
export const SOP_FORBID_TAGS = Object.freeze([
  'style',
  'form',
  'button',
  'textarea',
  'select',
  'option',
])

export function sanitizeSopHtml(html) {
  return DOMPurify.sanitize(html, { FORBID_TAGS: [...SOP_FORBID_TAGS] })
}
